module.exports = __webpack_public_path__ + "static/media/Desktop_Actions_36.1971a8cf.png";